import React from "react";
import colors from "../../common/colors";
import AnchorLink from "../../components/AnchorLink";
import Checkbox from "../../components/Checkbox";
import FormInvalidError from "../../components/FormInvalidError";
import {
    CellBlockField,
    CellBlockProperty,
    CellBlockSection,
    CellBlockTitle,
    CellBlockValue,
} from "../../components/Grid/CellBlock";
import { OrdererInfoData } from "./OrdererInfoForm";
import { ordererRoleLabel } from "./ordererDetailsConfig";

interface OrdererInfoListingProps {
    data: OrdererInfoData;
    isValid: boolean;
    showRole?: boolean;
}

const OrdererInfoListing = (props: OrdererInfoListingProps) => {
    const { firstName, lastName, phone, email, customerCreationAllowed, municipalityRole } =
        props.data;

    return (
        <>
            <CellBlockSection>
                <CellBlockTitle>{`${firstName} ${lastName}`}</CellBlockTitle>
            </CellBlockSection>
            {props.showRole && (
                <CellBlockSection>
                    <CellBlockProperty>Roll</CellBlockProperty>
                    <CellBlockValue>{ordererRoleLabel(municipalityRole)}</CellBlockValue>
                </CellBlockSection>
            )}
            <CellBlockSection>
                <CellBlockProperty>Telefon</CellBlockProperty>
                <CellBlockValue>{phone}</CellBlockValue>
            </CellBlockSection>
            <CellBlockSection>
                <CellBlockProperty>E-postadress</CellBlockProperty>
                <CellBlockField>
                    <AnchorLink>{email}</AnchorLink>
                </CellBlockField>
            </CellBlockSection>
            {customerCreationAllowed && (
                <CellBlockSection>
                    <Checkbox
                        value={true}
                        text="Får lägga till nya slutkunder"
                        iconColor={colors.grayDark}
                        readOnly
                    />
                </CellBlockSection>
            )}
            {!props.isValid && (
                <CellBlockSection>
                    <FormInvalidError />
                </CellBlockSection>
            )}
        </>
    );
};

export default OrdererInfoListing;
